import script from "./ParticipanteCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipanteCard.vue?vue&type=script&setup=true&lang=js"

import "./ParticipanteCard.vue?vue&type=style&index=0&id=34322c9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34322c9f"]])

export default __exports__